export default "__VITE_ASSET__D1B9ESAy__"